import { Swiper, SwiperSlide } from "swiper/react";
import { AddCerosToNumber } from "../actions/actions";
import { IModalidades, INumeroExtracto } from "../interfaces/interfaces";
import { v4 as uuid } from "uuid";
import { Autoplay, Navigation } from "swiper";
import { useEffect, useRef, useState } from "react";

interface Props {
  headsPoceada: IModalidades[];
  numerosExtractos: INumeroExtracto[];
  stateProxSorteo: number;
}

const ResumenPoceada = (props: Props) => {
  const { numerosExtractos, stateProxSorteo, headsPoceada } = props;

  const [itemSorteo, setItemSorteo] = useState<INumeroExtracto | null>(null);

  const swiperReff = useRef<any>();

  const diffHours = Math.floor((stateProxSorteo * -1) / 60);
  const diffMinutes = (stateProxSorteo * -1) % 60;

  useEffect(() => {
    headsPoceada && headsPoceada.length > 0 && getHeadModalidad(0);
  }, []);

  const getHeadModalidad = (i: number) => {
    let ItemSorteo = headsPoceada[i].items.find(
      (value) => value.NROSorteo === headsPoceada[i].NROSorteo
    );

    ItemSorteo && setItemSorteo(ItemSorteo as INumeroExtracto);
  };

  return (
    <>
      <div id="ResumenPOC" className="resumenSorteoPOC">
        <div className="extractoResumenHead">
          <div className="extractoResumenTitulo">
            {`Poceada Federal ${itemSorteo?.FechaSorteoSTR ?? ""} `}
            <strong className="hsClass">
              {itemSorteo?.HoraSorteo && `${itemSorteo?.HoraSorteo || ""}`}
            </strong>
          </div>
        </div>
        <div className="extractoResumenContainer">
          <Swiper
            spaceBetween={20}
            centeredSlides={true}
            autoplay={{
              delay: 20700,
              disableOnInteraction: true,
            }}
            grabCursor={true}
            pagination={{
              clickable: true,
            }}
            navigation={true}
            modules={[Autoplay, Navigation]}
            //className="mySwiper"
            onBeforeInit={(swiper) => {
              swiperReff.current = swiper;
            }}
            onActiveIndexChange={(swiperCore) => {
              getHeadModalidad(swiperCore.activeIndex);
            }}
          >
            {headsPoceada &&
              headsPoceada.length > 0 &&
              getSwiperSlider(headsPoceada)}
          </Swiper>
        </div>
      </div>

      <div id="ProximoSorteo">
        <span className="proxSorteo">Próximo Sorteo:</span>
        <div className="proxSorteoTime">{`${diffHours}h ${diffMinutes}m`}</div>
      </div>
    </>
  );

  function getSwiperSlider(headExtractoModalidad: IModalidades[]) {
    let array: JSX.Element[] = [];

    for (const i of headExtractoModalidad) {
      let numerosModalidad = numerosExtractos.filter(
        (numero) => numero.NROSorteo === i.NROSorteo
      );

      array.push(
        <SwiperSlide key={"swiperid" + i.NROSorteo}>
          {numerosModalidad &&
            numerosModalidad.length > 0 &&
            getNumerosPoceada(numerosModalidad)}
        </SwiperSlide>
      );
    }

    return array;
  }

  function getNumerosPoceada(numeros: INumeroExtracto[]) {
    let arrayArriba: JSX.Element[] = [];
    let arrayAbajo: JSX.Element[] = [];

    let numerosOrder = numeros.sort((a, b) => a.Valor - b.Valor);

    for (const i in numerosOrder) {
      const numero = numeros[i];
      let keyC = `colkeyP${numero.idModalidad}${uuid()}`;

      if (parseInt(i) < 10) {
        arrayArriba.push(
          <div key={keyC}>
            <div className="extractoNumeroResumen">
              {AddCerosToNumber(numero.Valor, 2)}
            </div>
          </div>
        );
      } else {
        arrayAbajo.push(
          <div key={keyC}>
            <div className="extractoNumeroResumen">
              {AddCerosToNumber(numero.Valor, 2)}
            </div>
          </div>
        );
      }
    }

    return (
      <div className="extractoResumenMedio">
        <div className="extractoBloqueNumResumen">{arrayArriba}</div>
        <div className="extractoBloqueNumResumen">{arrayAbajo}</div>
      </div>
    );
  }
};

export default ResumenPoceada;
